//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Base from './rb-base.vue'

import { ZERO_PLACEHOLDER } from '@/scripts/constants/placeholders'
import { StringUtils } from '@/scripts/libs/string-utils'
export default {
  name: 'rb-textarea',
  extends: Base,
  props: {
    rows: {
      type: Number,
    },
    cols: {
      type: Number,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    isFocus: {
      type: Boolean,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      ZERO_PLACEHOLDER,
    }
  },
  computed: {
    remainChars() {
      return Math.max(0, this.maxlength - this.value?.length)
    },
    helperLabel() {
      return this.helper && this.remainChars
        ? StringUtils.parse(this.helper, [this.remainChars])
        : ''
    },
  },
}
